import api from './api'

export type LifecycleTarget = { kind: 'tenant'; tenantId: string } | { kind: 'user'; userId: string } | { kind: 'membership'; tenantId: string; userId: string }
export type LifecycleHistory = { id: string; actor_user_id: string; action: string; reason: string; created_at: string }
export interface LifecycleImpact {
  tenant?: { id: string; name: string; status: string; lifecycle_previous_status: string | null }
  user?: { id: string; email: string; status: string; active: boolean }
  membership?: { id: string; tenant_id: string; user_id: string; name: string; status: string }
  memberships?: Array<{ tenant_id: string; name: string; status: string }>
  counts?: Record<string, number>
  dependencies?: Array<{ type: string; count: number }>
  blockers?: string[]
  explanation: string
  history: LifecycleHistory[]
}
const endpoint = (target: LifecycleTarget) => target.kind === 'user'
  ? `/api/system/lifecycle/users/${encodeURIComponent(target.userId)}`
  : `/api/system/lifecycle/tenants/${encodeURIComponent(target.tenantId)}${target.kind === 'membership' ? `/memberships/${encodeURIComponent(target.userId)}` : ''}`
export const getLifecycleImpact = async (target: LifecycleTarget) => (await api.get(endpoint(target))).data as LifecycleImpact
export const changeLifecycle = async (target: LifecycleTarget, input: { action: string; reason: string; expectedStatus: string; confirmation: true }) => (await api.post(endpoint(target), input)).data
export function lifecycleActions(target: LifecycleTarget, impact: LifecycleImpact) {
  if (target.kind === 'membership') return impact.membership?.status === 'disabled' ? [] : ['remove']
  if (target.kind === 'user') return impact.user?.status === 'deleted' ? [] : impact.user?.status === 'active' ? ['suspend'] : ['reactivate']
  return impact.tenant?.status === 'archived' ? ['restore'] : impact.tenant?.status === 'suspended' ? ['reactivate', 'archive'] : ['suspend', 'archive']
}
